export const API_BASE_URL: string = (import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000/v1').replace(
  /\/+$/,
  '',
);

/** Throw on response/schema drift instead of warning (see .env.example). */
export const STRICT_SCHEMAS: boolean = import.meta.env.VITE_STRICT_SCHEMAS === 'true';
